import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

/**
 * Eyebrow — handoff COMPONENTS §14
 * Mono 10px, letter-spacing 0.10em, uppercase, weight 600, color fg-muted
 */
export function Eyebrow({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'font-mono text-[10px] tracking-[0.10em] uppercase font-semibold text-fg-muted',
        className,
      )}
    >
      {children}
    </span>
  );
}
